import { Injectable } from '@angular/core';
import { CommonService } from 'src/app-core/services/common.service';
import { ApiCommonService } from 'src/app-core/services/api-common.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class VehiclesService {

  constructor(private apiCommonService: ApiCommonService) {
  }

  getGridRecords(event: any, searchQuery: string, statusQuery: string): Observable<any> {
    return this.apiCommonService.getGridRecords('Vehicle', event, searchQuery, statusQuery, '');
  }

  getVehicle(vehicleId: string): Observable<any> {
    return this.apiCommonService.get(`vehicle/Id?Id=${vehicleId}`);
  }

  exportVehicle(event: any, searchQuery: string, statusQuery: any): Observable<object> {
    return this.apiCommonService.export('Vehicle/export', event, searchQuery, statusQuery, '');
  }

  createVehicle(data: object): Observable<object> {
    return this.apiCommonService.post('Vehicle', data);
  }

  updateVehicle(data: object): Observable<object> {
    return this.apiCommonService.put('Vehicle/Update', data);
  }

  getDrivers(): Observable<any> {
    return this.apiCommonService.get(`Vehicle/DriverLookUp`);
  }

  vehicleStatusUpdate(data: object): Observable<object> {
    return this.apiCommonService.put('Vehicle/Delete', data);
  }

  createNotes(data: object): Observable<object> {
    return this.apiCommonService.put('Vehicle/AddNotes', data);
  }

  getNotesGridRecords(event: any, queryparams: string): Observable<any> {
    return this.apiCommonService.getGridRecords('Vehicle/NoteList', event, queryparams, '', '');
  }

  getVehicleNotes(vehicleNotesId: string): Observable<any> {
    return this.apiCommonService.get('Vehicle/Note?VehicleNoteId=' + vehicleNotesId);
  }

  getVehicles(): Observable<any> {
    return this.apiCommonService.get(`Vehicle/LookUp`);
  }
}
